import { useHomepageData } from "../../hooks/useHomepageData";

export default function WhoWeAreSection() {
  const { data } = useHomepageData();
  const whoWeAreData = data.whoWeAreSection;

  return (
    <section
      aria-labelledby="who-we-are"
      className="relative px-4 lg:px-16 py-16 lg:py-24 flex items-center justify-center"
    >
      <div className="space-y-6 text-center">
        <h2
          id="who-we-are"
          className="text-4xl lg:text-6xl font-medium text-[#d9d9d9] tracking-wide"
        >
          {whoWeAreData.title}
        </h2>

        <p className="relative text-lg lg:text-xl text-white leading-relaxed py-8 md:py-14 px-8 md:px-32 rounded-[13px] border border-[#1179F9]">
          {whoWeAreData.description}
        </p>
      </div>
    </section>
  );
}
